import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/task-list/task-list-table.module.css";

export default {
  "cellText": "task-list-table-module__cellText_l6nXtq__100",
  "taskListCell": "task-list-table-module__taskListCell_l6nXtq__100",
  "taskListEmptyExpander": "task-list-table-module__taskListEmptyExpander_l6nXtq__100",
  "taskListExpander": "task-list-table-module__taskListExpander_l6nXtq__100",
  "taskListNameWrapper": "task-list-table-module__taskListNameWrapper_l6nXtq__100",
  "taskListTableRow": "task-list-table-module__taskListTableRow_l6nXtq__100",
  "taskListWrapper": "task-list-table-module__taskListWrapper_l6nXtq__100"
};
      